import React, { useEffect, useState } from "react";
import { Save, Phone, MessageCircle, Mail, MapPin, Instagram, Music2, Youtube, FileText } from "lucide-react";
import api from "@/lib/api";
import { errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

function Field({ item, value, onChange, label, icon: Icon, placeholder, textarea }) {
  return (
    <div className="bg-white rounded-xl p-3 border border-slate-100">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-slate-700">
          {Icon && <Icon className="w-4 h-4 text-slate-500" />} {label}
        </div>
        <div className="flex items-center gap-1.5">
          <span className={`text-[11px] font-semibold ${value.active ? "text-emerald-600" : "text-slate-400"}`}>{value.active ? "Aktiv" : "Joaktiv"}</span>
          <Switch data-testid={`toggle-${item}`} checked={value.active} onCheckedChange={(v) => onChange({ ...value, active: v })} />
        </div>
      </div>
      {textarea ? (
        <Textarea data-testid={`field-${item}`} rows={4} value={value.value} onChange={(e) => onChange({ ...value, value: e.target.value })} placeholder={placeholder} className="text-sm" />
      ) : (
        <Input data-testid={`field-${item}`} value={value.value} onChange={(e) => onChange({ ...value, value: e.target.value })} placeholder={placeholder} className="text-sm" />
      )}
    </div>
  );
}

export default function AdminFooterSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => setS(r.data)).catch(() => {});
  }, []);

  if (!s) return <p className="text-center text-slate-400 py-6 text-sm">Duke ngarkuar...</p>;

  const set = (group, key, val) => setS((p) => ({ ...p, [group]: { ...p[group], [key]: val } }));

  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/admin/settings", s);
      setS(r.data);
      toast.success("Ndryshimet u ruajtën");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-sm font-bold text-slate-900 mb-2 px-1">Kontakt</h3>
        <div className="space-y-2">
          <Field item="phone" label="Telefon" icon={Phone} placeholder="+383 44 123 456" value={s.contact.phone} onChange={(v) => set("contact", "phone", v)} />
          <Field item="whatsapp" label="WhatsApp" icon={MessageCircle} placeholder="+383 44 123 456" value={s.contact.whatsapp} onChange={(v) => set("contact", "whatsapp", v)} />
          <Field item="viber" label="Viber" icon={Phone} placeholder="+383 44 123 456" value={s.contact.viber} onChange={(v) => set("contact", "viber", v)} />
          <Field item="email" label="Email" icon={Mail} placeholder="info@gjejshqip.com" value={s.contact.email} onChange={(v) => set("contact", "email", v)} />
          <Field item="address" label="Adresë" icon={MapPin} placeholder="Rruga, Qyteti, Shteti" value={s.contact.address} onChange={(v) => set("contact", "address", v)} />
        </div>
      </div>

      <div>
        <h3 className="text-sm font-bold text-slate-900 mb-2 px-1">Rrjetet sociale</h3>
        <div className="space-y-2">
          <Field item="instagram" label="Instagram URL" icon={Instagram} placeholder="https://instagram.com/..." value={s.social.instagram} onChange={(v) => set("social", "instagram", v)} />
          <Field item="tiktok" label="TikTok URL" icon={Music2} placeholder="https://tiktok.com/@..." value={s.social.tiktok} onChange={(v) => set("social", "tiktok", v)} />
          <Field item="youtube" label="YouTube URL" icon={Youtube} placeholder="https://youtube.com/@..." value={s.social.youtube} onChange={(v) => set("social", "youtube", v)} />
        </div>
      </div>

      <div>
        <h3 className="text-sm font-bold text-slate-900 mb-2 px-1">Faqet</h3>
        <div className="space-y-2">
          <Field item="privacy" label="Privatësia" icon={FileText} textarea placeholder="Teksti i politikës së privatësisë..." value={s.pages.privacy} onChange={(v) => set("pages", "privacy", v)} />
          <Field item="terms" label="Kushtet" icon={FileText} textarea placeholder="Teksti i kushteve të përdorimit..." value={s.pages.terms} onChange={(v) => set("pages", "terms", v)} />
          <Field item="report" label="Raporto problem" icon={FileText} textarea placeholder="Udhëzime / info për të raportuar një problem..." value={s.pages.report} onChange={(v) => set("pages", "report", v)} />
        </div>
      </div>

      <button data-testid="save-settings-btn" onClick={save} disabled={saving} className="w-full bg-emerald-500 hover:bg-emerald-600 active:scale-[0.99] transition-all text-white rounded-xl py-3 text-sm font-bold flex items-center justify-center gap-2 disabled:opacity-60">
        <Save className="w-4 h-4" /> {saving ? "Duke ruajtur..." : "Ruaj ndryshimet"}
      </button>
    </div>
  );
}
